import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { FocusAreas } from './components/FocusAreas';
import { PhilosophySection } from './components/PhilosophySection';
import { BrandMoment } from './components/BrandMoment';
import { FloatingOrbs } from './components/FloatingOrbs';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
function Divider() {
  return <div className="w-full flex justify-center py-12 opacity-30 relative z-10" data-id="element-0" data-mp="2mjznn7gejtnm">
      <div className="w-1/3 md:w-1/4 h-px bg-brand-gold" data-id="element-1" data-mp="31c1iue7j1yhb" />
    </div>;
}
function Home() {
  return <div className="min-h-screen bg-brand-dark text-brand-offWhite selection:bg-brand-gold/30 selection:text-brand-offWhite font-sans relative" data-id="element-2" data-mp="2whx9xpepbgdl">
      <FloatingOrbs data-id="element-3" data-mp="23vul23bheeqe" />
      <main className="relative z-10" data-id="element-4" data-mp="23ujkecdc1n3i">
        <HeroSection data-id="element-5" data-mp="23ti864kkyuk7" />
        <Divider data-id="element-6" data-mp="3ik7ekc2063oj" />
        <AboutSection data-id="element-7" data-mp="3ikqz80j1f669" />
        <Divider data-id="element-8" data-mp="3ijfx0558q6h9" />
        <FocusAreas data-id="element-9" data-mp="3ihv22ef0kliv" />
        <Divider data-id="element-10" data-mp="3mlj8gtrwtb2j" />
        <PhilosophySection data-id="element-11" data-mp="3ml1397n9rmih" />
        <Divider data-id="element-12" data-mp="3mk852v2dm5by" />
        <BrandMoment data-id="element-13" data-mp="3mjq2zht18ww4" />
      </main>
    </div>;
}
export function App() {
  useEffect(() => {
    document.title = 'Pollock Ventures';
  }, []);
  return <BrowserRouter data-id="element-14" data-mp="6htjo98ovic">
      <Routes data-id="element-15" data-mp="4n4pyuukj8z">
        <Route path="/" element={<Home data-id="element-17" data-mp="7svdij4jt6t" />} data-id="element-16" data-mp="5gbv0xpxarn" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-19" data-mp="2zm4xcjfp5b1a" />} data-id="element-18" data-mp="2zld2xbxu5jcl" />
        <Route path="/terms" element={<TermsOfService data-id="element-21" data-mp="33mowttnqsqql" />} data-id="element-20" data-mp="2zmwhmy3ufmc9" />
      </Routes>
    </BrowserRouter>;
}